import React from "react";
import { useHistory } from "react-router-dom";
import { CircleCheck, CircleDraft, CirclePlus } from "../TableIcons/TableIcons";
import styles from "./OneToOne.module.css";

const OneToOneTable = (props) => {
  const { employeeEmail, isLineManagerView } = props;
  const history = useHistory();

  const toOneToOnePrepPage = (year, period) => {
    if (!isLineManagerView) {
      history.push(`/new-1-2-1/${year.replace("/", "-")}/${period}`);
    }
  };

  const toEditPrepPage = (id) => {
    if (!isLineManagerView) {
      history.push(`/edit-1-2-1/${id}`);
    }
  };

  const toView121Page = (id) => {
    history.push(
      isLineManagerView ? `/my-team/${employeeEmail}/view-1-2-1/${id}` : `/view-1-2-1/${id}`
    );
  };

  const toView121PageNoPrep = (year, period) => {
    history.push(
      isLineManagerView
        ? `/my-team/${employeeEmail}/view-1-2-1/${year.replace("/", "-")}/${period}`
        : `/view-1-2-1/${year.replace("/", "-")}/${period}`
    );
  };

  const tableClicked = (item) => {
    if (isLineManagerView) {
      if (item.oneToOneComplete) {
        toView121Page(item.id);
      } else if (!item.prepComplete && !item.id) {
        toView121PageNoPrep(item.year, item.period);
      } else {
        toView121Page(item.id);
      }
    } else if (!item.prepComplete && !item.id) {
      toOneToOnePrepPage(item.year, item.period);
    } else if (item.oneToOneComplete) {
      toView121Page(item.id);
    } else if (!item.prepComplete && item.id) {
      toEditPrepPage(item.id);
    } else {
      toView121Page(item.id);
    }
  };

  return (
    <table className={styles.TableView} role="grid">
      <thead>
        <tr aria-label="One to One table row">
          <th>Period</th>
          {props.tableData &&
            props.tableData.map((item) => (
              <td
                id="tabToMe"
                key={item.period}
                role="gridcell"
                className={styles.activeCell}
                tabIndex={0}
                onClick={() => tableClicked(item)}
                onKeyDown={(e) => (e.key === "Enter" ? tableClicked(item) : undefined)}
              >
                <div className={styles.period}>{item.period}</div>
              </td>
            ))}
        </tr>
      </thead>
      <tbody>
        <tr aria-label="One to One table row">
          <th>Prep Complete?</th>
          {props.tableData &&
            props.tableData.map((item) => (
              <td
                key={item.period}
                role="gridcell"
                className={styles.activeCell}
                tabIndex={0}
                onClick={() => tableClicked(item)}
              >
                {item.prepComplete && <CircleCheck />}
                {item.prepStarted && !item.prepComplete && item.id && <CircleDraft />}
                {!item.prepStarted && !item.prepComplete && <CirclePlus />}
              </td>
            ))}
        </tr>
        <tr>
          <th>1-2-1 Complete?</th>
          {props.tableData &&
            props.tableData.map((item) => (
              <td
                key={item.period}
                role="gridcell"
                className={styles.activeCell}
                tabIndex={0}
                onClick={() => tableClicked(item)}
                aria-label={item.oneToOneComplete ? "complete" : "incomplete"}
              >
                {item.oneToOneComplete ? <CircleCheck /> : <CirclePlus />}
              </td>
            ))}
        </tr>
      </tbody>
    </table>
  );
};

export default OneToOneTable;
